import { defineStore } from 'pinia';
import { ref } from 'vue';
import { ledgerApi, type LedgerEntry, type LedgerType } from '../api/ledger';

export const useLedgerStore = defineStore('ledger', () => {
  const entries = ref<LedgerEntry[]>([]);
  const nextCursor = ref<string | null>(null);
  const types = ref<LedgerType[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);
  const pageSize = 50;

  async function reset(): Promise<void> {
    entries.value = [];
    nextCursor.value = null;
    await loadMore();
  }

  async function loadMore(): Promise<void> {
    if (loading.value) return;
    loading.value = true;
    error.value = null;
    try {
      const res = await ledgerApi.list({
        limit: pageSize,
        cursor: nextCursor.value ?? undefined,
        types: types.value.length > 0 ? types.value : undefined,
      });
      entries.value = nextCursor.value === null ? res.entries : [...entries.value, ...res.entries];
      nextCursor.value = res.next_cursor;
    } catch (err) {
      error.value = (err as Error).message;
    } finally {
      loading.value = false;
    }
  }

  function setTypes(next: LedgerType[]): void {
    types.value = next;
    void reset();
  }

  return { entries, nextCursor, types, loading, error, pageSize, reset, loadMore, setTypes };
});
